import { DatePipe } from '@angular/common';
import { Component, TemplateRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import {
  DxDataGridComponent
} from 'devextreme-angular';
import ArrayStore from 'devextreme/data/array_store';
import CheckBox from 'devextreme/ui/check_box';
import * as _ from 'lodash';
import { defineLocale } from 'ngx-bootstrap/chronos';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { enGbLocale } from 'ngx-bootstrap/locale';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { ToastrService } from 'ngx-toastr';
import { ISubscription } from "rxjs/Subscription";
import { environment } from '../../shared/config/app-config';
import { CallService, FormSessionCanDeactivate, PatientService, UserService } from '../../shared';
import { User } from '../../shared/models';
import { TranslateService } from '@ngx-translate/core';
//import {HeaderComponent} from '../../shared/index'

@Component({
  templateUrl: 'dash.component.html',
  styleUrls: ['./style.component.css']
})
export class DashComponent extends FormSessionCanDeactivate {
  bundleEndDateStatus: boolean;
  bundleStatus: boolean;
  setmask: string;
  pacEventName: any;
  paclist: any;
  dropdownPacSettings: { singleSelection: boolean; idField: string; textField: string; selectAllText: string; unSelectAllText: string; itemsShowLimit: number; allowSearchFilter: boolean; };
  phoneset: string;
  maxdate18: boolean;
  tooltipnew: any;
  index: any;
  showloder: boolean;
  delpat: any;
  selpat: string = 'Select Patient';
  multiple: string = 'multiple';
  reasontype: any;
  selCare: string;
  modalRef1: BsModalRef;
  modalRef2: BsModalRef;
  modalRef3: BsModalRef;
  lengthcn: any;
  careList: any;
  select: boolean;
  dataSource: ArrayStore;
  tempother: boolean;
  cloudeImageURL: string = environment.cloudeImageURL;
  public reassign: any = {}
  public addcustom = {
    "description": '',
    "duedate": '',
    "subject": '',
  }
  temppat: any;
  surgicalstage: ({ text: string; value: (string | number)[]; } | { text: string; value: (string | number)[][]; })[];
  statuswithinvalidcontact: ({ text: string; value: (string | number | boolean)[]; } | { text: string; value: (string | number | boolean)[][]; })[];
  group: any;
  surdis: boolean;
  disabled: boolean;
  @ViewChild(DxDataGridComponent) dataGrid: DxDataGridComponent;
  exportTooltip = 'Export All Data';
  getTotalPageCount() {
    return this.userService.translateText('hospital_portal.mytodos.pagination.label');
  }
  enablepatient: boolean;
  emp: any;
  showinvaild1: boolean;
  showinvaild: boolean;
  traccount: any;
  selectedItemKeys: any[] = [];
  public objs: any = {

  };
  dropdownPSettings: { singleSelection: boolean; idField: string; textField: string; selectAllText: string; unSelectAllText: string; itemsShowLimit: number; allowSearchFilter: boolean; };
  dropdownSSettings: { singleSelection: boolean; idField: string; textField: string; selectAllText: string; unSelectAllText: string; itemsShowLimit: number; allowSearchFilter: boolean; };
  surg: any;
  prod: any;
  dtdownloadOptions: any = {};
  hosp: any;
  down_care: {};
  downloadcare: boolean = false
  tempvar: boolean;
  timealert: any = environment.timelimit;
  tractionlist: any;
  hospid: any;
  suglist: any;
  serviceline: any;
  modalDataArray: any = [];
  public data: Object;
  modalRef: BsModalRef;
  modaldata: any;
  track: any;
  tempmsg: any;
  public name: any;
  public temp_var: boolean = false;
  public dateformat = environment.dateFormat;
  public dateform = environment.dateForm;
  public bsConfig = Object.assign({}, { containerClass: 'theme-dark-blue', showWeekNumbers: false, dateInputFormat: this.dateformat });
  CurrentUser: User;
  dateFormat = {
    date: {
      pipe: this.dateform
    }
  };
  date: any = {
    'dos': "04/13/2018"
  }

  @ViewChild('videoPlayer') videoplayer: any;
  public patient: any;
  public patname: any;
  public download_care: any = environment.downloadcare;
  public apiurl: any = environment.api_url;
  public caremap: any = environment.practiceid;
  public str: any = {}
  empdetails: any = {}
  public currentUser: any;
  dtOptions: any = {};
  detail: any = {};
  emp1: any;
  downloaddata: any = {
    pacEventName: ''
  }
  dropdownList = [];
  selectedItems = [];
  dropdownSettings = {};
  newreq: boolean = true;
  Download: boolean = false;
  dates = new Date()
  mintododata: Date = new Date(this.dates.setDate(this.dates.getDate()));
  subscription: ISubscription;
  popout: boolean = false;
  filterValue: any;
  preferredLanguage = '';
  constructor(
    private route: ActivatedRoute,
    private toastr: ToastrService,
    private modalService: BsModalService,
    private callService: CallService,
    private router: Router,
    private patientservice: PatientService,
    private userService: UserService,
    private Datepipe: DatePipe,
    private localeService: BsLocaleService,
    private translate: TranslateService
  ) {
    super();
    this.translate.setDefaultLang(userService.defaultLang); 
    this.filterValue = []
    if (localStorage.getItem("patFilter")) {
      this.filterValue = JSON.parse(atob(localStorage.getItem("patFilter")));
    }
    enGbLocale.invalidDate = '';
    enGbLocale.weekdaysShort = ['S', 'M', 'T', 'W', 'T', 'F', 'S'];
    enGbLocale.week.dow = 0;
    defineLocale('custom locale', enGbLocale);
    this.localeService.use('custom locale');

    this.subscription = callService.patcomponentMethodCalled$.subscribe(
      () => {
        this.temp_var = false;
        this.ngOnInit();
        this.dataGrid.instance.clearFilter();
        this.dataGrid.instance.clearSelection();
      }
    );
    this.preferredLanguage = this.userService.selectedLang();
    this.exportTooltip = this.userService.translateText('hospital_portal.mytodos.export_all_data.tooltip');
  }

  ngOnDestroy() {
    // alert("Destroy Calling Here");
    if (!!this.subscription) {
      this.subscription.unsubscribe();
    }
    if (this.popout) {
      this.modalRef.hide();
    }
  }


  // ngOnChanges(){
  //   this.ngOnInit();
  // }
  /*  getPatientDataByMode(mode) {
      this.UserService.getPatientDataMde(mode).subscribe(
        data => {
          this.hospitalList = data;
  
        });
    }
  */
  // ***************************************************
  // Get Patient List - Mode value - Current/Archive/All 
  //****************************************************
  setMode: any = 'current';
  getPatientDatamode() {
    //this.setMode=mode;
    this.ngOnInit()
  }

  public imageURL: string = environment.cloudeImageURL;
  popupinfoicon: boolean = false;
  viewpatsummary(patswfid) {
    let tempvar = { patSWFId: patswfid }
    this.userService.setTempVar(tempvar)
    this.router.navigate([`/care/patientsummary`])
  }
  ngOnInit() {
    // if (window.localStorage['superClientId'] == '1') {
    //   this.popupinfoicon = true
    // }
    // else {
    //   this.popupinfoicon = false
    // }
    this.disabled = false;
    // this.subscription.unsubscribe();
    this.route.params.subscribe((params: Params) => {
      ////console.log(params); 
      // this will be called every time route changes
      // so you can perform your functionality here

    });
    this.userService.currentUser.subscribe(
      (userData) => {
        this.currentUser = userData;
        this.currentUser.status = false;
        if (this.currentUser.item) {
          this.bundleStatus = this.currentUser.item.bundleStatus;
          this.bundleEndDateStatus = this.currentUser.item.bundleEndDateStatus
          this.setmask = this.currentUser.item.phoneFormat.split('#').join('0').concat('0');
          if (this.currentUser.item.dateFormat) {
            if (this.currentUser.item.dateFormat.toLowerCase() == 'mmddyyyy') {
              this.dateformat = environment.dateFormat;
              this.dateform = environment.dateForm;

            } else if (this.currentUser.item.dateFormat.toLowerCase() == 'ddmmyyyy') {
              this.dateformat = 'DD/MM/YYYY'
              this.dateform = 'dd/MM/yyyy'
              this.dateFormat = {
                date: {
                  pipe: this.dateform
                }
              };
            }
            this.bsConfig = Object.assign({}, { containerClass: 'theme-dark-blue', showWeekNumbers: false, dateInputFormat: this.dateformat });
            if (this.currentUser.item) {
              if (this.currentUser.item.hostModel == "CLOUD")
                this.imageURL = environment.cloudeImageURL;
              else
                this.imageURL = environment.vmImageURL;
            } else
              this.imageURL = environment.vmImageURL;
          }
        }
      }
    )


    this.patient = [];
    this.showloder = true;
    this.patientservice
      .getpatientlist(this.currentUser.item.userAccountId, this.setMode) // patientlist setMode value 
      .subscribe(
        data => {
          this.temp_var = true;
          this.showloder = false;
          this.patient = data;
          //console.log(this.patient, "PatientLis")
          for (var i = 0; i < this.patient.length; i++) {
            //if (this.patient[i].payorType == 'Medicare' && this.patient[i].bpci && this.patient[i].cjr != 'Y' && this.currentUser.item.clientType == "BPCIA") {
            if (this.patient[i].payorType == 'Medicare' && this.patient[i].bpci && this.patient[i].cjr != 'Y' && this.currentUser.item.clientType && this.currentUser.item.clientType.search("BPCIA") != -1) {
              this.patient[i].group = 'BPCI-A-' + this.patient[i].bpci;
            }
            else if (this.patient[i].cjr == 'Y' && this.patient[i].payorType == 'Medicare') {
              this.patient[i].group = 'CJR';
            }
            else if (this.patient[i].payorType == 'Commercial' && this.currentUser.item.commercialType) {
              this.patient[i].group = 'Commercial';
            }
            else {
              this.patient[i].group = '';
            }
            if (this.patient[i].fracture == 'Y') {
              this.patient[i].fract = this.userService.translateText('hospital_portal.mytodos.fracture.column')
            }
            if (this.patient[i].mako == 'Y') {
              this.patient[i].mak = this.userService.translateText('hospital_portal.add_patient.robotics.label')
            }

            // Invalid Email ToolTip
            if (!this.patient[i].patEmailValid && !this.patient[i].patPhoneValid) {
              this.patient[i].emailValidTooltip = this.userService.translateText('hospital_portal.patientls.invalid_email_mobile.tooltip');
            }
            else if (!this.patient[i].patEmailValid) {
              this.patient[i].emailValidTooltip = this.userService.translateText('hospital_portal.patientls.invalid_email.tooltip');
            }
            else if (!this.patient[i].patPhoneValid) {
              this.patient[i].emailValidTooltip = this.userService.translateText('hospital_portal.patientls.invalid_mobile.tooltip');
            }
            else if (!this.patient[i].cpEmailValid && !this.patient[i].cpPhoneValid) {
              this.patient[i].emailValidTooltip = this.userService.translateText('hospital_portal.patientls.invalid_carepartner_email_mobile.tooltip');
            }
            else if (!this.patient[i].cpEmailValid) {
              this.patient[i].emailValidTooltip = this.userService.translateText('hospital_portal.patientls.invalid_carepartner_email.tooltip');
            }
            else if (!this.patient[i].cpPhoneValid) {
              this.patient[i].emailValidTooltip = this.userService.translateText('hospital_portal.patientls.invalid_carepartner_mobile.tooltip');
            }



          }
          this.dataSource = new ArrayStore({
            key: "ID",
            data: this.patient
          });
          this.showloder = false;
        }

      );
    this.surgicalstage = [{
      text: "Pre-Op",
      value: [
        ["surgicaldaysdiff", "<", 0],
        ["surgicaldaysdiff", ">", -8888888]
      ]
    }, {
      text: "Post-Op",
      value: [
        ["surgicaldaysdiff", ">=", 0]
      ]
    }, {
      text: "Non-Op",
      value: [
        ["surgicaldaysdiff", "=", -8888888]
      ]
    }];

    this.statuswithinvalidcontact = [{
      text: "Invited",
      value: [
        ['patientStatus', "=", 'Invited']
      ]
    }, {
      text: "Up to speed",
      value: [
        ['patientStatus', "=", 'Up to speed']
      ]
    }, {
      text: "Falling Behind",
      value: [
        ['patientStatus', "=", 'Falling Behind']
      ]
    },
    {
      text: "Not Enrolled",
      value: [
        ['patientStatus', "=", 'Not Enrolled']
      ]
    }, {
      text: "Opted-Out",
      value: [
        ['patientStatus', "=", 'Opted-Out']
      ]
    },
    {
      text: "Invalid Contact",
      value: [
        ['cpEmailValid', '=', false],
        ['cpPhoneValid', '=', false],
        ['patPhoneValid', '=', false],
        ['patEmailValid', '=', false]
        // this.patient.filter(it => {
        //   !it.cpEmailValid || !it.cpPhoneValid 
        //   || !it.patPhoneValid || !it.patEmailValid
        // })
      ]

    }];


    if (this.currentUser.item.userrole == 'Care Navigator' || this.currentUser.item.userrole == 'Care Coordinator' || this.currentUser.item.userrole == 'Hospital Care Navigator' || this.currentUser.item.userrole == 'Commercial Care Navigator' || this.currentUser.item.userrole == 'Surgeon' || this.currentUser.item.userrole == 'Patient Enroller' || this.currentUser.item.userGroupId == 32 || this.currentUser.item.userGroupId == 33) {
      if (this.currentUser.item.userrole == 'Surgeon') {
        this.surdis = true
        this.disabled = false;
      }

      this.userService
        .gethosp(this.currentUser.item.userAccountKey, this.currentUser.item.userAccountId)
        .subscribe(
          data => {
            //  ////console.log(data)
            this.dropdownList = data;
            ////console.log(this.dropdownList)
          }
        );

      this.patientservice
        .getSurgeonlist(this.currentUser.item.userAccountId)
        .subscribe(
          data => {
            ////console.log(data)
            //  this.dropdownList = data;
            this.suglist = data
          }
        );
      this.userService
        .getDisList(this.currentUser.item.userAccountKey)
        .subscribe(
          data => {
            ////console.log(data)
            this.paclist = data;
            this.paclist.forEach(element => {
              element.typeName = element.dischargeTypeName
            });
          }
        );
      this.patientservice
        .getBodyLocation(this.currentUser.item.userAccountKey)
        .subscribe(
          data => {

            this.serviceline = data.ServicelineLabel;
            this.serviceline = _.remove(this.serviceline, (o: any): any => {
              return o.ServicelineLabel.toLowerCase() != "other."
            })
            // if (data.Location.length) {
            //   let index = _.findIndex(data.ServicelineLabel, (o: any): any => {
            //     return o.Location == "Knee"
            //   })
            //   if (index != -1)
            //     this.serviceline.push(this.objs)


            // }

          }

        );
      this.countdownload();
      this.caredownload();
      this.loadCareList();
      this.dtdownloadOptions = {
        // Configure the pagelength
        pageLength: 5,
        lengthMenu: [[5, 10, 25, -1], [5, 10, 25, "All"]],
        order: [[0, "desc"]],
        columnDefs: [{ type: "date", targets: [0] }, { orderable: false, targets: [2] }]


      };
    }
    else {
      this.disabled = true
    }
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'hospitalId',
      textField: 'HospitalName',
      selectAllText: 'Select All',
      unSelectAllText: 'Unselect All',
      itemsShowLimit: 2,
      allowSearchFilter: true
    };
    this.dropdownSSettings = {
      singleSelection: false,
      idField: 'UserAccountId',
      textField: 'SurgeonName',
      selectAllText: 'Select All',
      unSelectAllText: 'Unselect All',
      itemsShowLimit: 2,
      allowSearchFilter: true
    };
    this.dropdownPSettings = {
      singleSelection: false,
      idField: 'ServicelineLabel',
      textField: 'ServicelineLabelDisplayName',
      selectAllText: 'Select All',
      unSelectAllText: 'Unselect All',
      itemsShowLimit: 2,
      allowSearchFilter: true
    };
    this.dropdownPacSettings = {
      singleSelection: true,
      idField: 'dischargeTypeName',
      textField: 'dischargeTypeDisplayName',
      selectAllText: 'Select All',
      unSelectAllText: 'Unselect All',
      itemsShowLimit: 2,
      allowSearchFilter: true
    };


    this.dtOptions = {
      // Configure the pagelength
      pageLength: 10,
      lengthMenu: [[10, 25, 50, 100, -1], [10, 25, 50, 100, "All"]],
      dom: 'Blfrtip',
      columnDefs: [{ type: "date", targets: [5] }, { type: "date", targets: [8] }],
      buttons: [
        {
          extend: 'excelHtml5',
          exportOptions: {
            columns: [1, 2, 3, 4, 5, 6, 7, 8, 10, 11]
          },
          text: 'Download Excel',
          className: 'datatablebuttons btn btn-chnag buttons-pdf buttons-html5',
          title: this.getTitle()
        },
        {
          extend: 'pdfHtml5',
          exportOptions: {
            columns: [1, 2, 3, 4, 5, 6, 7, 8, 10, 11]
          },
          orientation: 'landscape',
          text: 'Download PDF',
          className: 'datatablebuttons btn btn-chnag buttons-pdf buttons-html5',
          title: this.getTitle()
        },

      ]
    };

  }

  private static getOrderDay(rowData) {
    if (!rowData.cpEmailValid || !rowData.cpPhoneValid || !rowData.patPhoneValid || !rowData.patEmailValid) {
      return true
    }
    return false
  }
  private static getFilterOrderDay(rowData) {
    if (!rowData.cpEmailValid || !rowData.cpPhoneValid || !rowData.patPhoneValid || !rowData.patEmailValid) {
      return rowData.patientStatus
    }
    return false
  }
  calculateFilterExpression(value, selectedFilterOperations, target) {
    let column = this as any;
    if (target == "headerFilter" && value == "Invalid Contact" && column.filterValues && column.filterValues.length == 1) {
      return [[DashComponent.getOrderDay, '=', true]];
    }
    else if (target == "headerFilter" && value == "Invited" && column.filterValues && column.filterValues.length > 1 && column.filterValues.includes('Invalid Contact')) {
      return [[DashComponent.getFilterOrderDay, '=', "Invited"]];
    } else if (value == "Up to speed" && target == "headerFilter" && column.filterValues && column.filterValues.length > 1 && column.filterValues.includes('Invalid Contact')) {
      return [[DashComponent.getFilterOrderDay, '=', "Up to speed"]];
    } else if (value == "Falling Behind" && target == "headerFilter" && column.filterValues && column.filterValues.length > 1 && column.filterValues.includes('Invalid Contact')) {
      return [[DashComponent.getFilterOrderDay, '=', "Falling Behind"]];
    }
    else if (value == "Not Enrolled" && target == "headerFilter" && column.filterValues && column.filterValues.length > 1 && column.filterValues.includes('Invalid Contact')) {
      return [[DashComponent.getFilterOrderDay, '=', "Not Enrolled"]];
    }
    else if (value == "Opted-Out" && target == "headerFilter" && column.filterValues && column.filterValues.length > 1 && column.filterValues.includes('Invalid Contact')) {
      return [[DashComponent.getFilterOrderDay, '=', "Opted-Out"]];
    }
    return column.defaultCalculateFilterExpression.apply(this, arguments);
  }


  orderHeaderFilter(data) {
    data.dataSource.postProcess = (results) => {
      results.push({
        text: "Invalid Contact",
        value: "Invalid Contact"
      });
      return results;
    };
  }



  loadCareList() {
    this.userService.getCareList(this.currentUser.item.userAccountKey, this.currentUser.item.userAccountId)
      .subscribe(
        data => {
          this.careList = data;
          this.lengthcn = this.careList.length
          if (this.currentUser.item.cnmappingct == 0 || this.currentUser.item.userAccountId == this.caremap) {
            this.selCare = 'ALL'
          } else {
            this.selCare = data.find(it => it.CNID == this.currentUser.item.userAccountId).CNID;
            this.currentUser.item.selectCNUserId = this.selCare;
          }
          this.selCare = ''
          ////console.log("select CN", this.selCare);

        }
      );
  }
  selectRowId: any = [];
  deselectRowId: any = [];
  selectionChanged(data: any) {
    data.selectedRowKeys = [];
    this.selectRowId = []; this.deselectRowId = []; this.selectedItemKeys = [];
    data.selectedRowsData.filter(obj => {
      if (obj.patientStatus != 'Archived')
        return this.selectRowId.push(obj.ID)
      else {
        return this.deselectRowId.push(obj.ID)
      }
    });
    data.selectedRowsData = data.selectedRowsData.filter(obj => obj.patientStatus != 'Archived');
    data.selectedRowKeys = this.selectRowId
    data.currentSelectedRowKeys = this.selectRowId
    data.currentDeselectedRowKeys = this.deselectRowId
    this.selectedItemKeys = data.selectedRowKeys;
    if (this.selectedItemKeys.length > 0) {
      this.select = true

    } else {
      this.select = false
      this.selpat = 'Reassign To'
      this.selCare = ''
    }
  }
  selectRecords() {
    /* this.selectedItemKeys.forEach((key) => {
        this.dataSource.remove(key);
    }); */

    if (this.multiple == '') {
      this.multiple = 'multiple';
    }
    this.dataGrid.instance.refresh();
  }


  //On Edit Preparing based on Patient Status
  onCellPrepared(e) {
    if (e.rowType == "data" && e.column.command == 'select' && e.data.patientStatus == 'Archived') {
      var editor = CheckBox.getInstance(e.cellElement.querySelector(".dx-select-checkbox"));
      editor.option("disabled", true);
      e.cellElement.style.pointerEvents = 'none';
    }
  }


  carenav(showassign: TemplateRef<any>, todoConfig: TemplateRef<any>) {

    ////console.log(event,this.selCare)
    let patid = []
    this.selectedItemKeys.forEach((key) => {
      /* alert('Patient Id'+this.patient[key].ID+'--------'+'carnav id'+event ) */
      patid.push(this.patient[key - 1].patientSWId)
    });
    let stykeradmin = window.localStorage['superClientId']
    let pat = patid.toString()
    this.reassign = {
      assignedTo: this.selCare,
      assignedFrom: this.patientservice.CN_id ? this.patientservice.CN_id : 0,
      patSWFId: pat,
      userAccId: this.currentUser.item.userAccountId,
      userAccountKey: this.currentUser.item.userAccountKey,
      stykerAdmin: stykeradmin ? stykeradmin : 0
    }

    this.getTodoConfigurationStatus(this.reassign.userAccId, this.reassign.assignedTo, showassign, todoConfig);


    this.movable()
  }

  getConfigtodo: any;
  getTodoConfigurationStatus(userAccId, assignedTo, showassign, todoConfig) {
    this.patientservice.getTodoConfigurationStatus(this.reassign)
      .subscribe(data => {
        this.getConfigtodo = data;

        if (this.getConfigtodo.Status == 'true') {
          this.modalRef1 = this.modalService.show(todoConfig, {
            class: 'modal-sm'
          })
        }
        else {
          this.modalRef1 = this.modalService.show(showassign, {
            class: 'modal-sm'
          })
        }
      })
  }


  btnenable: boolean
  yestoshow() {
    this.btnenable = true
    this.patientservice
      .reassigncn(this.reassign)
      .subscribe(
        data => {
          if (data) {
            this.toastr.toastrConfig.timeOut = 3000;
            this.dataGrid.instance.clearSelection()
            this.toastr.success(this.currentUser.item.userrole + this.userService.translateText('hospital_portal.disp_messages.reassigned_successfully.success'));
            this.btnenable = false
            this.userService.logAudit("Cn Reassign", 0).subscribe(data => { })
            this.ngOnInit();
            this.select = false
            this.multiple = 'multiple';
            this.selpat = 'Select Patient'
          }

        }
      );
    this.modalRef1.hide();
  }

  notoshow() {
    this.multiple = 'multiple';
    this.selpat = 'Select Patient'
    this.modalRef1.hide();
  }
  newfun(e) {

    this.tooltipnew = e;
    this.phoneset = e.teleCode + ' - ' + e.phone
    if (this.tooltipnew.imagePath.search("default_") != -1)
      this.tooltipnew.deaultimg = true
    else
      this.tooltipnew.deaultimg = false
  }

  countdownload() {
    this.patientservice
      .gettransactionList(this.currentUser.item.userAccountId)
      .subscribe(
        data => {
          this.traccount = data.Count;

        }
      );
  }
  caredownload() {
    this.tempvar = false
    this.patientservice
      .transactionList(this.currentUser.item.userAccountId, this.currentUser.item.userAccountKey)
      .subscribe(
        data => {
          this.tractionlist = data;
          this.tempvar = true
          ////console.log(data)
        }
      );

  }
  careplan(templatecareplan: TemplateRef<any>) {
    this.popout = true;
    this.modalRef = this.modalService.show(templatecareplan, { class: 'modal-lg', backdrop: "static" });
    this.movable()
  }

  req() {
    this.newreq = true;
    this.Download = false;
  }
  down() {

    this.newreq = false;
    this.Download = true;
    this.caredownload()
    this.patientservice
      .puttransactionList(this.currentUser.item.userAccountId)
      .subscribe(
        data => {
          this.userService.logAudit('Download Care Plan get Archive List', 0).subscribe(data => { })
          this.countdownload()
        }
      );

  }
  onItemSelect(item: any) {
    ////console.log(item);
    let ab: any = new Array<any>();
    if (item) {
      ab.push(item.HospitalPracticeId)
    }
    if (this.hosp == undefined || this.hosp == "" || this.hosp == null)
      this.hosp = ab.toString()
    else
      this.hosp = this.hosp + ',' + ab.toString()
  }
  onSItemSelect(item: any) {
    ////console.log(item);
    let ab: any = new Array<any>();
    if (item) {
      ab.push(item.UserAccountId)
    }
    if (this.surg == undefined || this.surg == "" || this.surg == null)
      this.surg = ab.toString()
    else
      this.surg = this.surg + ',' + ab.toString()
  }
  onPacItemSelect(item: any) {
    ////console.log(item);
    let ab: any = new Array<any>();
    if (item) {
      ab.push(item)
    }
    if (this.pacEventName == undefined || this.pacEventName == "" || this.pacEventName == null)
      this.pacEventName = ab.toString()
    else
      this.pacEventName = this.pacEventName + ',' + ab.toString()
  }
  onPItemSelect(item: any) {
    ////console.log(item);
    let ab: any = new Array<any>();
    let id: any = null;
    if (item) {
      ab.push(item)
    }
    if (this.prod == undefined || this.prod == "" || this.prod == null)
      this.prod = ab.map(el => el.ServicelineLabel) .toString();
    else
      this.prod = this.prod + ',' + ab.map(el => el.ServicelineLabel) .toString();
  }
  onItemDeSelect(item: any) {
    ////console.log(item);
    let ab = this.hosp.split(',')
    ab = _.reject(ab, (o) => {
      return o == ''
    })
    if (item) {
      ab = _.reject(ab, (o) => {
        return o == item.HospitalPracticeId
      })
    }
    this.hosp = ab.toString()
  }
  onSItemDeSelect(item: any) {
    ////console.log(item);
    let ab = this.surg.split(',')
    ab = _.reject(ab, (o) => {
      return o == ''
    })
    if (item) {
      ab = _.reject(ab, (o) => {
        return o == item.UserAccountId
      })
    }
    this.surg = ab.toString()

  }
  onPacItemDeSelect(item: any) {
    ////console.log(item);
    let ab = this.pacEventName.split(',')
    ab = _.reject(ab, (o) => {
      return o == ''
    })
    if (item) {
      ab = _.reject(ab, (o) => {
        return o == item
      })
    }
    this.pacEventName = ab.toString()
  }
  onPItemDeSelect(item: any) {
    ////console.log(item);
    let ab = this.prod.split(',')
    ab = _.reject(ab, (o) => {
      return o == ''
    })
    if (item) {
      ab = _.reject(ab, (o) => {
        return o == item
      })
    }
    this.prod = ab.map(el => el.ServicelineLabel) .toString();
  }
  onItemDeSelectAll(items: any) {
    this.hosp = null
  }
  onSItemDeSelectAll(items: any) {
    this.surg = null
  }
  onPItemDeSelectAll(items: any) {
    this.prod = null
  }
  onPacItemDeSelectAll(items: any) {
    this.pacEventName = null
  }
  onSelectAll(items: any) {
    ////console.log(items);
    let ab: any = new Array<any>();
    if (items) {
      items.forEach(element => {
        ////console.log(element.HospitalPracticeId)
        ab.push(element.HospitalPracticeId);

      });
      ////console.log(ab.toString())
      this.hosp = ab.toString();

    }
    else {
      this.hosp = null;

    }
  }
  onPacSelectAll(items: any) {
    ////console.log(items);
    let ab: any = new Array<any>();
    if (items) {
      items.forEach(element => {
        ////console.log(element)
        ab.push(element);

      });
      ////console.log(ab.toString())
      this.pacEventName = ab.toString();

    }
    else {
      this.pacEventName = null;

    }
  }
  onPSelectAll(items: any) {
    ////console.log(items);
    let ab: any = new Array<any>();
    if (items) {
      items.forEach(element => {
        ////console.log(element)
        ab.push(element);

      });
      ////console.log(ab.toString())
      this.prod = ab.map(el => el.ServicelineLabel) .toString();
    }
    else {
      this.prod = null;

    }
  }
  onSSelectAll(items: any) {
    ////console.log(items);
    let ab: any = new Array<any>();
    if (items) {
      items.forEach(element => {
        ////console.log(element.UserAccountId)
        ab.push(element.UserAccountId);

      });
      ////console.log(ab.toString())
      this.surg = ab.toString();

    }
    else {
      this.surg = null;

    }
  }
  /*open(template: TemplateRef<any>,emp: any) {
    this.empdetails = emp;
    
    this.patname = emp.firstName +" "+ emp.lastName;
    this.modalRef = this.modalService.show(template);
  }  */

  updatestatus(templatestatus: TemplateRef<any>, emp: any) {
    this.detail = emp;
    this.modalRef = this.modalService.show(templatestatus, { class: 'appointment', backdrop: 'static' });
    this.movable()
    this.patientservice

      .gettrack(this.detail.patientSWId)

      .subscribe(
        data => {

          this.track = data;
          this.modalDataArray = this.track[emp.currentStageName]
        }
      );
  }

  getTitle() {
    return `Patient List`
  }
  updatedetils(idspass, namepass) {
    let tempvar = { name: idspass, id: namepass }
    this.userService.setTempVar(tempvar)
    this.router.navigate([`/care/anybodypart`])


  }
  openModel(confirm: TemplateRef<any>, emp) {
    let self = this;
    this.modalRef = self.modalService.show(confirm, { class: 'modal-sm', backdrop: 'static' })
    this.movable()
    this.emp = emp
    this.enablepatient = true
    self.popout = true
  }

  /** Cancel and start here */
  cancelPatientSWFid: string;
  openCancel(template: TemplateRef<any>, id) {
    this.modalRef = this.modalService.show(template, { class: 'modal-sm', backdrop: 'static' });
    this.movable()
    this.cancelPatientSWFid = id;
  }
  openModelphone(confirm: TemplateRef<any>, emp) {
    let self = this;
    this.modalRef = self.modalService.show(confirm, { class: 'modal-sm', backdrop: 'static' })
    this.movable()
    this.emp = emp;
    this.enablepatient1 = true
    self.popout = true;
  }

  infodetils(idspass, type) {
    //////console.log(idspass);
    //////console.log(namepass);
    this.enablepatient = false
    this.patientservice
      .getpatientemail(idspass, this.currentUser.item.userAccountId, type)
      .subscribe(
        data => {
          if (data) {
            this.toastr.toastrConfig.timeOut = 3000;
            if (type == 'email')
              this.toastr.success(this.userService.translateText('hospital_portal.disp_messages.email_sent.success'));
            else
              this.toastr.success(this.userService.translateText('hospital_portal.disp_messages.sms_sent.success'));
          }
          else {
            this.toastr.toastrConfig.timeOut = 3000;
            if (type == 'email')
              this.toastr.error(this.userService.translateText('hospital_portal.disp_messages.email_not_found.error'));
            else
              this.toastr.error(this.userService.translateText('hospital_portal.disp_messages.sms_not_found.error'));
          }

          this.modalRef.hide()
        }
      );
  }
  enablepatient1: boolean;
  saveDos(msg) {
    //////console.log(msg.value);
    let msgvalue = {

      "dos": msg.value.desp
    }
    //////console.log(msgvalue);
    this.patientservice
      .getpatientdos(msgvalue)
      .subscribe(
        data => {
          if (data.status = "Success") {
            this.toastr.toastrConfig.timeOut = 3000;
            this.toastr.success(this.userService.translateText('hospital_portal.disp_messages.msg_sent.success'));


          }
          else {
            this.toastr.toastrConfig.timeOut = 3000;
            this.toastr.success(this.userService.translateText('hospital_portal.disp_messages.msg_not_sent.error'));

          }
        }
      );

  }


  cancelScheduleObj: any;
  //Cancel Plan
  cancelSchedule(patientSWFId) {
    this.patientservice.cancelSurgery(this.cancelPatientSWFid,
      this.currentUser.item.userAccountId).subscribe(
        data => {
          this.modalRef.hide();
          this.cancelScheduleObj = data;
          this.ngOnInit();

          if (this.cancelScheduleObj.status == "true") {
            this.userService.logAudit('cancelSurgery', 0).subscribe(data => { })
            this.toastr.success(this.cancelScheduleObj.message, '', { timeOut: this.timealert });
          } else
            this.toastr.error(this.cancelScheduleObj.message, '', { timeOut: this.timealert })
        })
  }

  setAuth(user: User) {
    if (user.item.appRoles == "PRACTICE" || user.item.appRoles == "HOSPITAL") {
      this.router.navigateByUrl('/care/mytodo')
    }
    else if (user.item.appRoles == "PATIENT") {
      this.userService
        .postuserinfoid('1', user.item.userAccountId)
        .subscribe(
          data => {
            for (var i = 0; i < data.length; i++) {
              if (data[i].patientStageWorkflow.length == 1) {
                this.userService.setUser(data[i].patientStageWorkflow[i]);
                this.router.navigateByUrl('/patient/dashboard')
              }
              else {
                this.router.navigateByUrl('/home')
              }
            }
          }
        );
    }
    else if (user.item.appRoles == "SOLVEDGE") {
      this.router.navigateByUrl('/admin/dashboard')
    }
  }

  pauseOrPlay(video) {
    video.pause();
    video.currentTime = 0;
  }

  total(da) {

    ////console.log(da)

    let id: any;
    let surg: any;
    let prod: any;
    if (da.hosp) {
      let ab: any = new Array<any>();
      da.hosp.forEach(element => {
        ////console.log(element.HospitalPracticeId)
        ab.push(element.HospitalPracticeId);

      });
      ////console.log(ab.toString())
      id = ab.toString();
      ////console.log(id)
    }
    else {
      id = null;

    }
    if (da.surgeon) {
      let ab: any = new Array<any>();
      da.surgeon.forEach(element => {
        ////console.log(element.UserAccountId)
        ab.push(element.UserAccountId);

      });
      ////console.log(ab.toString())
      surg = ab.toString();
      ////console.log(surg)

    }
    else {
      surg = null;

    }
    if (da.proty) {
      prod = JSON.stringify(da.proty);
      ////console.log(prod)
    }
    else {
      prod = null;

    }
    this.surg = surg
    this.hosp = id
    this.prod = prod
    this.savedownload(id)


  }
  savedownload(id) {
    let sentarray = {
      "bpcia": this.downloaddata.bpci,
      "clientId": this.currentUser.item.userAccountKey,
      "completed": false,
      "completedDate": null,
      "dashboardTransactionId": null,
      "dosFrom": this.downloaddata.from,
      "dosTo": this.downloaddata.to,
      "filePath": null,
      "hospitalPracticeId": id,
      "hspSugId": this.surg,
      "procedureType": this.prod,
      "pacEventName": this.downloaddata.pacEventName,
      "requestedBy": this.currentUser.item.userAccountId,
      "requestedDate": null
    }
    this.patientservice.savedownload(sentarray)
      .subscribe(
        data => {

          if (data.Status.toLowerCase() == 'success') {
            this.toastr.success(data.Message + this.userService.translateText('hospital_portal.disp_messages.req_processed_completed.success'), '', {
              timeOut: 5000
            })
            this.userService.logAudit('saveDashboardTransaction', 0).subscribe(data => { })
            this.downloaddata = {
              pacEventName: ''
            }
            this.hosp = null
            this.surg = null
            this.prod = null
            this.pacEventName = null
            this.tempvar = false
            this.caredownload()
            //this.modalRef.hide()
          }
          else if (data.Status.toLowerCase() == "failure") {
            this.toastr.error(data.Message, '', {
              timeOut: this.timealert
            })
          }
        }
      );
  }
  resetdownload() {
    this.downloaddata = {
      pacEventName: ''
    }
    this.hosp = ""
    this.surg = ""
    this.prod = ""
    this.downloadcare = false
    this.req()
    this.modalRef.hide()
  }
  downloadcareinfo(trac) {

    this.downloadcare = true
    let hospital = '';
    let hosp: any = new Array<any>();
    if (trac.HospitalPracticeId) {

      let hosp_id = trac.HospitalPracticeId.split(',')
      for (var l = 0; l < hosp_id.length; l++) {
        for (var m = 0; m < this.dropdownList.length; m++) {
          if (hosp_id[l] == this.dropdownList[m].HospitalPracticeId) {
            if (hosp_id[0])
              hosp.push(this.dropdownList[m].HospitalName)

          }
        }
      }
      hospital = hosp
    }
    else {
      hospital = ''
    }
    let surgeon = '';
    let surg: any = new Array<any>();
    if (trac.Hsp_Sug_Id) {
      let sur_id = trac.Hsp_Sug_Id.split(',')
      for (var j = 0; j < sur_id.length; j++) {
        for (var i = 0; i < this.suglist.length; i++) {
          if (sur_id[j] == this.suglist[i].UserAccountId) {
            surg.push(this.suglist[i].SurgeonName)
          }
        }
      }
      surgeon = surg
    }
    else {
      surgeon = ''
    }
    if (trac.ProcedureType) {
      var proc = trac.ProcedureType.split(",")
      ////console.log("proc", proc)
    }

    this.down_care = {
      'RequestedDate': trac.RequestedDate,
      'DosFrom': trac.DosFrom,
      'DosTo': trac.DosTo,
      'surgeon': surgeon,
      'ProcedureType': proc,
      'hospital': hospital,
      'bpci': trac.BPCIA

    }
  }
  back() {
    this.downloadcare = false
    this.down_care = {}
  }
  dateValueChange(event) {
    if (event.keyCode != 8) {
      if (event.target.value.length == 2 || event.target.value.length == 5) {
        var thisVal = event.target.value;
        thisVal += '/';
        event.target.value = thisVal;
      }
    }
  }
  checkempty(id) {
    ////console.log(id)
    if (id == '' || id == null || id == 'Invalid Date') {
      this.showinvaild = true
    } else if (id != '' && id != null) {
      this.showinvaild = false
    }
  }

  checkempty1(id) {
    ////console.log(id)
    if (id == '' || id == null || id == 'Invalid Date') {
      this.showinvaild1 = true
    } else if (id != '' && id != null) {
      this.showinvaild1 = false
    }
  }

  public incexcObject: any = {
    includeexcHeader: "",
    BPCIStatus: "",
    type: "",
    checkboxname: ""
  }

  mytodoBundle: any = false;
  currentPatientDetails: any;
  ExcIncresult: any;
  cards: any = false;
  reasonbundle: any;
  other: any;
  Other: any;
  reason: any = ''
  popupExcIncBPCI(includeExcludeBundle: TemplateRef<any>, incexcStatus: string, type: string, currentPatient: any, i, reason) {
    this.index = currentPatient.ID - 1
    this.currentPatientDetails = currentPatient;
    this.incexcObject.type = type;
    if (reason) {
      this.reason = reason
    }
    if (type == "exclude") {
      this.popout = true
      this.incexcObject.includeexcHeader = "BPCI - "+this.userService.translateText('hospital_portal.mytodos.exclude_bundle.label');;
      this.incexcObject.checkboxname = "Exclude";
      this.cards = currentPatient.excludeCareCards ? currentPatient.excludeCareCards : false;
      this.mytodoBundle = currentPatient.excludeMyTodo ? currentPatient.excludeMyTodo : false;

      if (currentPatient.excludeReason == "Insurance change" || currentPatient.excludeReason == "Patient expired during hospital stay" || currentPatient.excludeReason == "Patient expired after hospital discharge" || currentPatient.excludeReason == "Patient's procedure switched to outpatient") {
        this.reasonbundle = currentPatient.excludeReason;
        this.other = "";
      } else if (currentPatient.excludeReason) {
        this.reasonbundle = "Other";
        this.other = currentPatient.excludeReason == 'Other' ? '' : currentPatient.excludeReason;
      } else {
        this.reasonbundle = "";
        this.other = "";
      }
      this.incexcObject.BPCIStatus = incexcStatus;
      this.modalRef = this.modalService.show(includeExcludeBundle, { class: 'modal-md', backdrop: "static" });
    } else {
      this.popout = true
      this.mytodoBundle = true;
      this.cards = true;
      this.incexcObject.includeexcHeader = "BPCI - " + this.userService.translateText('hospital_portal.mytodos.include_bundle.label');
      this.incexcObject.checkboxname = "Include";
      this.incexcObject.BPCIStatus = incexcStatus;
      this.modalRef = this.modalService.show(includeExcludeBundle, { class: 'modal-md', backdrop: "static" });
    }
    this.movable()
  }

  onChangeBPCI() {
    this.other = "";
  }

  changeBPCI() {

    if (this.other) {
      this.reasonbundle = this.other;
    }
    this.userService
      .ExcIncBPCIAPI(this.currentPatientDetails.patientSWId, this.mytodoBundle, this.currentUser.item.userAccountId, this.incexcObject.type, this.cards, this.reasonbundle)
      .subscribe(
        data => {
          this.ExcIncresult = data;
          if (this.ExcIncresult.status == "true") {
            if (this.incexcObject.type == "exclude") {

              this.patient[this.index].bpci = "N"
              this.patient[this.index].group = 'BPCI-A-' + this.patient[this.index].bpci;
              this.patient[this.index].excludeReason = this.reasonbundle;
              this.patient[this.index].excludeCareCards = this.cards;
              this.patient[this.index].excludeMyTodo = this.mytodoBundle;
              this.currentPatientDetails.bpci = "N";
            }
            else {
              this.patient[this.index].bpci = "Y"
              this.patient[this.index].group = 'BPCI-A-' + this.patient[this.index].bpci;
              this.currentPatientDetails.bpci = "Y";
              this.patient[this.index].excludeReason = '';
              this.patient[this.index].excludeCareCards = '';
              this.patient[this.index].excludeMyTodo = '';
            }

            this.userService.logAudit("excludeBundle", 0).subscribe(data => { })
            this.toastr.success(this.ExcIncresult.message, '', { timeOut: this.timealert });

          } else
            this.toastr.error(this.ExcIncresult.message, '', { timeOut: this.timealert })

        }
      );
    this.dataSource = new ArrayStore({
      key: "ID",
      data: this.patient
    });
    this.dataGrid.instance.refresh();
    this.modalRef.hide();
    this.other = "";
  }
  close() {
    this.cards = false;
    this.mytodoBundle = false
    if (this.popout)
      this.popout = false
    if (this.tempother)
      this.tempother = false
    if (this.temppat)
      this.temppat.reason = false
    this.modalRef.hide()
  }
  deletepat(templatedel, pat) {
    this.temppat = pat;
    this.modalRef = this.modalService.show(templatedel, { class: 'modal-md', backdrop: "static" });
    this.movable()
    this.userService
      .getcheckmultipart(this.temppat.patientFk)
      .subscribe(
        data => {
          if (data) {
            this.delpat = data
          }
        }
      )
    this.userService
      .getdeletereasontype()
      .subscribe(
        data => {
          this.reasontype = data
        })

  }
  datachange(event) {
    this.temppat.reason = event.target.value
    if (event.target.value == 'Other') {
      this.tempother = true
    }
    else
      this.tempother = false
  }
  textdatachange(event) {
    this.temppat.reason = event.target.value
  }
  deletepatient() {
    // alert(JSON.stringify(this.temppat));
    let stykeradmin = window.localStorage['superClientId']
    this.userService
      .getdeletepat(this.temppat.patientFk, this.temppat.reason, stykeradmin ? stykeradmin : this.currentUser.item.userAccountId, this.currentUser.item.userAccountKey)
      .subscribe(
        data => {
          if (data) {
            this.toastr.success(this.userService.translateText('hospital_portal.disp_messages.patient_deleted.success'), '', { timeOut: this.timealert });
            this.userService.logAudit("Patient Deleted", 0).subscribe(data => { })
            this.ngOnInit()

          } else {
            this.toastr.error(this.userService.translateText('hospital_portal.disp_messages.patient_can_t_deleted.error'), '', { timeOut: this.timealert });

          }
        })
    this.modalRef.hide();
    this.temppat = ""
    this.tempother = false
  }

  //Maintain filter data
  FilterVal() {
    this.filterValue = this.dataGrid.filterValue;
    localStorage.setItem("patFilter", btoa(JSON.stringify(this.filterValue)));
  }

  //Clear  Filter data
  clearFilter(event) {
    this.dataGrid.instance.clearFilter();
    this.dataGrid.instance.clearSelection();
  }



  checkempty112(id, cusstatus) {
    let today = new Date();
    let curentdate = new Date(id)
    today.setDate(today.getDate());
    if (today.setHours(0, 0, 0, 0) <= curentdate.setHours(0, 0, 0, 0)) {
      this.maxdate18 = false;
    }
    if (today.setHours(0, 0, 0, 0) > curentdate.setHours(0, 0, 0, 0)) {
      this.addcustom.duedate = '';
      this.maxdate18 = true;
    }
  }

  addcust(addcustom: TemplateRef<any>) {
    this.modalRef2 = this.modalService.show(addcustom, { class: 'modal-md', backdrop: 'static' })
    this.movable()
  }

  onetapEnable: boolean = false
  newpop(addcustom, todo: TemplateRef<any>) {
    this.addcustom = addcustom.value;

    this.modalRef3 = this.modalService.show(todo, { class: 'modal-sm', backdrop: 'static' })
    this.movable()
  }

  adcust() {
    let patid = []
    this.onetapEnable = true
    this.selectedItemKeys.forEach((key) => {
      patid.push(this.patient[key - 1].patientSWId)
    });
    let pat = patid.toString()
    let stykeradmin = window.localStorage['superClientId']
    let data = {
      description: this.addcustom.description,
      dueDate: this.Datepipe.transform(this.addcustom.duedate, 'yyyy-MM-dd'),
      loginCcUaId: this.currentUser.item.userAccountId,
      patientSwfId: pat,
      todoCarePlanSurveyName: this.addcustom.subject,
      todoCategoryId: 12,
      stykerAdmin: stykeradmin ? stykeradmin : 0
    }
    this.patientservice.addcustom(data)
      .subscribe(data => {
        if (data[0].status == 'success') {
          this.toastr.success(this.userService.translateText('hospital_portal.disp_messages.custom_todos_added.success'), '', {
            timeOut: this.timealert
          })
          this.userService.logAudit('saveCustomTodoForMultiPatients', 0).subscribe(data => { })
          this.addcustom.subject = ""
          this.addcustom.duedate = ""
          this.addcustom.description = ""
          let date = new Date()
          this.mintododata = new Date(date.setDate(date.getDate()))
          this.onetapEnable = false
          this.modalRef3.hide()
          this.modalRef2.hide()
          this.dataGrid.instance.clearSelection();
          this.ngOnInit();
        } else {
          this.toastr.error(data[0].message, '', {
            timeOut: this.timealert
          })
        }
      })
  }

  popclose() {
    let date = new Date()
    this.mintododata = new Date(date.setDate(date.getDate()))
    if (this.modalRef3)
      this.modalRef3.hide()
    if (this.modalRef2)
      this.modalRef2.hide()
    this.addcustom.subject = ''
    this.addcustom.duedate = ''
    this.addcustom.description = ''
  }



  poclose() {
    let date = new Date()
    this.mintododata = new Date(date.setDate(date.getDate()))
    if (this.modalRef2)
      this.modalRef2.hide()
    this.addcustom.subject = ''
    this.addcustom.duedate = ''
    this.addcustom.description = ''
  }

  ponew() {
    let date = new Date()
    this.mintododata = new Date(date.setDate(date.getDate()))
    if (this.modalRef3)
      this.modalRef3.hide()
    if (this.modalRef2)
      this.modalRef2.hide()
    this.addcustom.subject = ''
    this.addcustom.duedate = ''
    this.addcustom.description = ''
    this.selpat = 'Select Patient'
    this.dataGrid.instance.clearSelection();
  }
  getdate(date) {
    if (this.currentUser.item.dateFormat.toLowerCase() == 'mmddyyyy') {
      return this.Datepipe.transform(date, environment.dateForm);
    } else if (this.currentUser.item.dateFormat.toLowerCase() == 'ddmmyyyy') {
      return this.Datepipe.transform(date, 'dd/MM/yyyy');
    }
  }
  getdatetime(date) {
    if (this.currentUser.item.dateFormat.toLowerCase() == 'mmddyyyy') {
      return this.Datepipe.transform(date, 'MM/dd/yyyy hh:mm a');
    } else if (this.currentUser.item.dateFormat.toLowerCase() == 'ddmmyyyy') {
      return this.Datepipe.transform(date, 'dd/MM/yyyy hh:mm a');
    }
  }
  movable() {
    $(function () {
      let modalContent: any = $('.modal-content');
      let modalHeader = $('.modal-header');
      modalHeader.addClass('cursor-all-scroll');
      modalContent.draggable({
        handle: '.modal-header'
      });
    });
  }

  invalidEmailRedirect(patDetails) {
    if (patDetails.patientStatus != 'Archived') {
      let tempvar = { patSWFId: patDetails.patientSWId }
      this.userService.setTempVar(tempvar)
      window.localStorage['patSWFId'] = btoa(JSON.stringify(tempvar))
      let patientName = patDetails.firstName + ' ' + patDetails.lastName;
      let patientDetails = {
        'patientId': patDetails.patientFk,
        'patientSWFId': patDetails.patientSWId,
        'patstatus': patDetails.patientStatus,
        'status': false
      }
      window.localStorage['patDetails'] = btoa(JSON.stringify(patientDetails))
      if (!patDetails.patPhoneValid || !patDetails.patEmailValid) {
        this.router.navigate([`care/patientdetails`])
      }
      else if (!patDetails.cpEmailValid || !patDetails.cpPhoneValid) {
        let careDetails = {
          'patientId': patDetails.patientFk,
          'patientSWFId': patDetails.patientSWId,
          'patientName': patientName,
          'patstatus': patDetails.patientStatus,
          'status': false,
          'partnerstatus': 'edit',
          'uid': patDetails.cpUseraccountId
        }
        window.localStorage['careDetails'] = btoa(JSON.stringify(careDetails))
        this.router.navigate([`care/addpartner`])
      }
    }
  }


  getBPCIA() {
    if (this.currentUser.item.clientType && this.currentUser.item.clientType.search("BPCIA") != -1)
      return 'BPCIA'
    else if (this.currentUser.item.clientType && this.currentUser.item.clientType.search("MAKO") != -1)
      return 'MAKO'
    else
      return false
  }
  // for todos popup
  openpopup(contentforpopup: TemplateRef<any>, patientSWId) {
    this.modalRef = this.modalService.show(contentforpopup, {
      class: 'modal-dialog modal-lg',
      ignoreBackdropClick: true
    });
    this.getTodoList(patientSWId);
    this.getQuickViewList();
  }
  todopopuparray: any
  getTodoList(patientSWId) {
    this.patientservice.ftechTodoListView(this.currentUser.item.userAccountKey, patientSWId).subscribe(data => {
      this.todopopuparray = data;
    })
  }
  quickViewpopuparray: any;
  getQuickViewList() {
    this.patientservice.ftechQuickView(this.currentUser.item.userAccountKey).subscribe(data => {
      this.quickViewpopuparray = data;
    })
  }
  customizeColumns(columns) {
    columns = columns.reduce((unique, o) => {
      if (!unique.some(obj =>
        (obj.caption == o.caption))) {
        o.visible = true
        unique.push(o);
      } else if (o.caption) {
        o.visible = false
      }
      return unique;
    }, []);
    for (var i = 1; i < columns.length; i++) {
      if (columns[i].caption) {
        columns[i].allowFiltering = false
        columns[i].cellTemplate = function (container, options) {
          let data = false
          options.data.todoAssociateViewBeanList.forEach(element => {
            if (!element.subTodo && element.todoCategoryShortTitle == options.column.caption) {
              data = true;
            } else if (element.subTodo) {
              element.subTodoAssociateViewBeanList.forEach(element1 => {
                if (element1.subTodoAssociated && element1.subTodoCategoryCode == options.column.caption) {
                  data = true
                }
              });
            }
          });
          if (options.column.dataField && data)
            $("<em>").addClass("text-success fa fa-check-circle-o text-center").appendTo(container);
          else
            $("<em>").addClass("text-danger fa fa-times-circle-o text-center").appendTo(container);
        }
      }
    }
  }
  getDownloadData() {
    let data: any = {
      bpcia: this.downloaddata.bpci,
      hsp_Sug_Id: this.surg,
      procedureType: this.prod || '',
      dosFrom: this.Datepipe.transform(this.downloaddata.from, 'yyyy-MM-dd'),
      dosTo: this.Datepipe.transform(this.downloaddata.to, 'yyyy-MM-dd'),
      clientId: this.currentUser.item.userAccountKey,
      hospitalPracticeId: this.hosp,
      currentPacEvent: this.downloaddata.pacEventName,
      userAccountId: this.currentUser.item.userAccountId,
      lang: this.userService.selectedLang()
    }
    console.log(data,"data")
    data = this.userService.encrypt(JSON.stringify(data))
    data = btoa(data)
    this.resetdownload()
    window.open(this.apiurl + this.download_care + data);
  }

  exportToExcel(event) {
    event.fileName = this.getTitle();
    this.dataGrid.instance.exportToExcel(false);
  }

  getLastLogin(lastlogindate) {
    if(lastlogindate) return this.userService.translateText('hospital_portal.mytodos.last_login_time.label') +" : "+ this.Datepipe.transform(new Date(lastlogindate), this.dateform);
    else ""
  }
}






